<template>
  <div>
    <b-alert :show="show" :variant="alertVariant" class="message-alert">
      <i :class="alertIcon"/>
      {{ message }}
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'MessageAlert',

  props: {
    show: {
      type: Boolean,
      default: true
    },

    message: {
      type: String,
      default: null
    },

    isSuccess: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    alertVariant () {
      if (this.isSuccess) {
        return 'success'
      }

      return 'danger'
    },

    alertIcon () {
      if (this.isSuccess) {
        return 'fa fa-check'
      }

      return 'fa fa-exclamation-triangle'
    }
  }
}
</script>
